import { useRef, useEffect } from 'react'
import { useInView } from 'motion/react'

/**
 * Wrapping component for sending GTM event when component is showed
 *
 * @param children
 * @param onVisible
 * @param onHide
 * @constructor
 */
export default function EverestVisibilityDetector({
  children,
  onVisible,
  onHide,
  once,
  offset,
  className = '',
}: {
  children: any
  onVisible?: () => void
  onHide?: () => void
  once?: boolean
  offset?: { top: number }
  className?: string
}) {
  const ref = useRef(null)
  const isInView = useInView(ref, {
    margin: offset ? `${offset.top}px 0px 0px 0px` : '0px',
    once,
  })

  useEffect(() => {
    if (isInView && onVisible) {
      onVisible()
    } else if (!isInView && onHide) {
      onHide()
    }
  }, [isInView, onVisible, onHide])

  return (
    <div ref={ref} className={`w-full h-full ${className}`}>
      {children}
    </div>
  )
}
